export default "__VITE_ASSET__N8eD4iDR__"